import Box from '@mui/material/Box';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import NoInternetConnection from './NoInternetConnection';
import Page from './Page';
import Sidebar from './Sidebar';

const SANS_FONT_STACK =
    'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(
        () => typeof window !== 'undefined' && window.innerWidth >= 1024
    );

    return (
        <Box
            sx={{
                display: 'flex',
                height: '100vh',
                bgcolor: '#f8fafc',
                color: '#0f172a',
                overflow: 'hidden',
                fontFamily: SANS_FONT_STACK,
            }}
        >
            {/* Sidebar */}
            <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />

            {/* Main Content */}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                    overflow: 'hidden',
                    position: 'relative',
                    transition: 'margin 300ms ease-in-out',
                    ml: 0,
                    '@media (min-width:1024px)': {
                        ml: sidebarOpen ? '16rem' : 0,
                    },
                }}
            >
                {/* Top Navigation */}
                <Navbar onMenuClick={() => setSidebarOpen((prev) => !prev)} />

                {/* Main Area */}
                <Box component="main" sx={{ flex: 1, overflowY: 'auto', width: '100%' }}>
                    <Box
                        sx={{
                            p: '1rem',
                            '@media (min-width:768px)': { p: '1.5rem' },
                            '@media (min-width:1024px)': { p: '2rem' },
                            maxWidth: '1600px',
                            mx: 'auto',
                            pb: '3rem',
                            '& > *:not(:first-of-type)': { mt: '1.5rem' },
                        }}
                    >
                        <Page>
                            <NoInternetConnection>
                                <Outlet />
                            </NoInternetConnection>
                        </Page>
                    </Box>
                </Box>

                {/* Footer */}
                <Box
                    component="footer"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        py: '0.5rem',
                        borderTop: '1px solid #e2e8f0',
                        bgcolor: '#ffffff',
                        px: '1rem',
                        '@media (min-width:768px)': { px: '2rem' },
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem',
                            fontSize: '0.75rem',
                            color: '#64748b',
                        }}
                    >
                        <span>Powered by</span>
                        <Box
                            component="a"
                            href="https://goldeninfotech.com.bd/"
                            target="_blank"
                            rel="noreferrer"
                            sx={{
                                transition: 'color 150ms',
                                '&:hover': { color: '#2563eb' },
                            }}
                        >
                            <Box
                                component="img"
                                src="/logo192.png"
                                alt="GDN Logo"
                                sx={{ maxHeight: '1.5rem', width: 'auto' }}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;
